import { ApiEnvironment } from '../../models/api-environment';

export class RoutingProfileServiceEnvironment extends ApiEnvironment {
  get routingProfilesDefaultUrl() {
    return `${this.baseUrl}/routing/v1/routingprofiles/default`;
  }

  get routingProfilesUrl() {
    return `${this.baseUrl}/routing/v1/routingprofiles`;
  }

  get routingProfilesNameUrl() {
    return `${this.baseUrl}/routing/v1/routingprofiles/name`;
  }

  get routingProfilesCostProfilesUrl() {
    return `${this.baseUrl}/routing/v1/routingprofiles/costprofiles`;
  }

  override resolve(environment: unknown) {
    return environment instanceof RoutingProfileServiceEnvironment
      ? environment
      : this;
  }
}

export const routingProfileServiceEnvironment =
  new RoutingProfileServiceEnvironment();
